import enMessages from './en';
import esMessages from './es';
import deMessages from './de';
import ptMessages from './pt';

export const messages = { 'pt-BR': ptMessages, 'en-US': enMessages, 'es-ES': esMessages, 'de-DE': deMessages };
